import React, { FC } from 'react';
import { useLocale } from '../../../../contexts/localeContext';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { WizardSummaryLayout, WizardSummarySection } from '../../../wizard/wizard-summary-layout';

interface SummaryProps {
    onBack: (e) => void;
    selectedBiometricDevices: string[];
}

const Summary: FC<SummaryProps> = ({ onBack, selectedBiometricDevices }) => {
    const { translate } = useLocale();

    return (
        <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.install)}>
            <WizardSummarySection heading={translate.byKey(TranslationKeys.selectedDevices)}>
                <ul className="p-1 text-xs text-black list-disc list-inside">
                    {selectedBiometricDevices.map((item) => (
                        <li key={item['address']}>
                            {item['baseDeviceName'] + ' (' + item['address'] + ')'}
                        </li>
                    ))}
                </ul>
            </WizardSummarySection>
        </WizardSummaryLayout>
    );
}

export default Summary;
